<template>
  <div class="rightBox">
    <div class="tab-box">
      <!-- 标题 -->
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in editableTabs" v-if="item.rowStatus" :key="index" :label="item.liveMenuName"
          :name="item.liveMenuType.toString()"></el-tab-pane>
      </el-tabs> -->
      <div class="tabs-header">
        <nav
          :class="activeName == item.liveMenuType ? 'active' : 'navItem'"
          v-for="(item, index) in editableTabs"
          v-if="item.rowStatus"
          :key="index"
          @click="handleClick(item.liveMenuType)"
        >
          {{ item.liveMenuName }}
        </nav>
      </div>
    </div>
    <!-- 内容 -->
    <!-- 评论区 -->
    <div class="tab-content" v-if="activeName === '6'">
      <div class="ev-detail-cont-commen">
        <div
          ref="commentBox"
          class="comment-list comment-box"
          style="overflow: hidden; overflow-y: auto;padding-top: 10px;"
          :style="{ height: tableHeight - 50 + 'px' }"
          v-if="msgList.length > 0 || topList.length > 0"
        >
            <div
              ref="answerTwzb"
              class="twzb answer-twzb comment-box"
              v-if="activeName === '6'"
            >
              <el-card class="box-card" style="height: 100%; overflow-y: auto">
                <div
                  style="
                    position: relative;
                    min-height:70px;
                    z-index: 20;
                    margin-top: -12px;
                  "
                  v-if="topList.length > 0"
                >
                  <div class="merryGoRound" ref="merryGoRound">
                    <el-carousel
                      min-height="70px"
                      direction="vertical"
                      :autoplay="true"
                      :loop="true"
                      indicator-position="none"
                    >
                      <el-carousel-item
                        v-for="(val, index) in topList"
                        :key="index"
                      >
                        <div class="user_send_msg">
                          <div class="user_send_msg_item">
                            <div class="user_send_msg_item_avatar">
                              <el-avatar
                                style="width: 28px; height: 28px"
                                shape="circle"
                                fit="cover"
                                :src="
                                  val.data.liveCommentHeadimg ||
                                  require('@/assets/zsLiveImage/zcr.png')
                                "
                              />
                            </div>
                            <div class="user_send_msg_item_info">
                              <div class="user_send_msg_item_nick_info">
                                <div class="user_send_msg_item_nick_info_name">
                                  {{ val.data.liveCommentName }}
                                </div>
                                <div
                                  class="user_send_msg_item_offic"
                                  v-if="val.data.liveCommentUserid == '主持人'"
                                >
                                  <img 
                                    style="width: 32px;height: 16px"
                                    src="@/assets/zsLiveImage/h5/gf.png"
                                    alt=""
                                  />
                                </div>
                                &emsp;
                                <img
                                  style="width: 32px;height: 16px;margin-left: 6px"
                                  src="@/assets/zsLiveImage/h5/zd.png"
                                  alt=""
                                />
                              </div>
                              <div class="user_send_msg_item_info_time">
                                {{ val.data.createTime.slice(5) }}
                              </div>
                            </div>
                          </div>
                          <div class="user_send_msg_content">
                            {{ val.data.liveCommentMessage }}
                          </div>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </div>
                <!-- <div
                  style="height: 100%"
                  class="border-box"
                  v-if="topList && topList.length"
                >
                  <div
                    class="text item"
                    v-for="(item, index) in topList"
                    :key="index"
                    style="padding-right: 0px"
                    :style="{
                      'border-color':
                        item.busType == 1 ? 'transparent' : '#f1f1f1',
                    }"
                  >
                    <div class="text-msg">
                      <div class="avatar-img">
                        <img
                          :src="
                            item.data.liveCommentHeadimg || userinfo.headimg
                          "
                          alt=""
                        />
                      </div>
                      <div class="zcrcalss">
                        <div class="user-name">
                          {{ item.data.liveCommentName }}
                          <span
                            class="user-info"
                            v-if="item.data.liveCommentName == '主持人'"
                            style="
                              background: #3a83ff;
                              margin-right: 8px;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            >官方</span
                          ><span
                            style="
                              background: #f83939;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            class="user-info"
                            v-if="item.data.liveCommentTopflag"
                            >置顶</span
                          >
                        </div>
                        <div class="createtime">
                          {{ item.data.createTime.slice(5) }}
                        </div>
                      </div>
                    </div>
                    <div class="twcontent" style="word-wrap: break-word">
                      <div class="question-box flex-between">
                        <div
                          v-if="item.operationType == 0 && item.busType !== 1"
                          class="question-right content-text comment-text"
                        >
                          {{ item.data.liveCommentMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="border-box" :style="{marginTop:topList.length > 0?'70px':'0px'}">
                  <div
                    v-if="
                      promptMsg.operationType == 0 && promptMsg.busType == 2
                    "
                    class="whoCome"
                  >
                    <span class="whoCome_address">{{ promptMsg.address }}</span
                    >{{ decodeURI(promptMsg.data) }}来了
                  </div>
                  <div
                    class="text item"
                    v-for="(item, index) in msgList"
                    :key="index"
                    style="padding-right: 0px"
                  >
                    <div
                      class="text-msg"
                      v-if="item.operationType == 0 && item.busType == 0"
                    >
                      <div class="avatar-img">
                        <img
                          :src="
                            item.data.liveCommentHeadimg || userinfo.headimg
                          "
                          alt=""
                        />
                      </div>
                      <div class="zcrcalss">
                        <div class="user-name">
                          {{ item.data.liveCommentName }}
                          <!-- <span
                            v-if="item.data.liveCommentName == '主持人'"
                            class="user-info"
                            style="
                              background: #2a7ac3;
                              margin-right: 8px;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            >官方</span
                          >
                          <span
                            style="
                              background: #ef983c;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            class="user-info"
                            v-if="item.data.liveCommentTopflag"
                            >置顶</span
                          > -->
                          <img style="width: 32px;height:16px" src="@/assets/zsLiveImage/h5/gf.png"  v-if="item.data.liveCommentName == '主持人'" alt="" />
                        </div>
                        <div class="createtime">
                          {{ item.data.createTime.slice(5) }}
                        </div>
                      </div>
                    </div>
                    <div class="twcontent" style="word-wrap: break-word">
                      <div class="question-box flex-between">
                        <div
                          v-if="item.operationType == 0 && item.busType !== 1"
                          class="question-right content-text comment-text"
                        >
                          {{ item.data.liveCommentMessage }}
                        </div>
                        <div class="gift-msg" v-if="item.busType == 1">
                          <div class="gift-word">
                            <span>{{ item.data.liveCommentName }}</span
                            >送出{{ item.data.liveCommentGiftcount }}个{{
                              item.data.liveCommentMessage
                            }}
                          </div>
                          <div
                            class="gift-img"
                            v-if="item.data.liveCommentGiftimg"
                          >
                            <img
                              :src="item.data.liveCommentGiftimg"
                              :alt="item.data.liveCommentMessage"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
        </div>
        <div
          v-else
          :style="{ height: tableHeight - 50 + 'px' }"
          style="width: 100%; height: 100%; position: relative"
        >
          <img
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 160px;
              height: 200px;
            "
            :src="require('@/assets/zsLiveImage/emptyH5.png')"
            alt=""
          />
        </div>
        <!-- <div class="question-msg-input">
          <div class="character-info">
            <div class="character">
              <div class="avatar-img">
                <img :src="userinfo.headimg" alt="" />
              </div>
            </div>
            <div class="character-send-content">
              <el-input v-model="msg" placeholder="请输入内容" maxlength="200" @keydown.enter.native="sendMsg" size="mini"
                v-if="liveUser.token">
              </el-input>
              <div class="video-login-tip" v-else>
                <span style="color: #3d7ddc; cursor: pointer" @click.stop="handleClickNeedLogin">登录</span>后可以参与直播互动
              </div>
              <div class="character-send-actions">
                <div class="character-send-actions-send" @click="sendMsg">
                  <img src="@/assets/zsLiveImage/video-send.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 互动聊天 -->
    <div class="tab-content" v-if="activeName === '0'">
      <div class="ev-detail-cont-commen">
        <div
          ref="commentBox"
          class="comment-list comment-box"
          style="overflow: hidden; overflow-y: auto"
          :style="{ height: tableHeight - 20 + 'px' }"
          v-if="msgList.length > 0"
        >
          <template>
            <div
              ref="answerTwzb"
              class="twzb answer-twzb comment-box"
              v-if="activeName === '0'"
            >
              <el-card
                class="box-card"
                style="height: 100%; overflow-y: auto"
                v-if="msgList && msgList.length > 0"
              >
                <div class="border-box" v-if="topList && topList.length">
                  <div
                    class="text item"
                    v-for="(item, index) in topList"
                    :key="index"
                    style="padding-right: 0px"
                    :style="{
                      'border-color':
                        item.busType == 1 ? 'transparent' : '#f1f1f1',
                    }"
                  >
                    <div class="text-msg">
                      <div class="avatar-img">
                        <img
                          :src="item.data.liveChatHeadimg || userinfo.headimg"
                          alt=""
                        />
                      </div>
                      <div class="zcrcalss">
                        <div class="user-name">
                          {{ item.data.liveChatName }}
                          <span
                            class="user-info"
                            v-if="item.data.liveChatName == '主持人'"
                            style="
                              background: #2a7ac3;
                              margin-right: 8px;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            >官方</span
                          ><span
                            style="
                              background: #ef983c;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            class="user-info"
                            v-if="item.data.liveChatTopflag"
                            >置顶</span
                          >
                        </div>
                        <div class="createtime">
                          {{ item.data.createTime.slice(5) }}
                        </div>
                      </div>
                    </div>
                    <div class="twcontent" style="word-wrap: break-word">
                      <div class="question-box flex-between">
                        <div
                          v-if="item.operationType == 0 && item.busType !== 1"
                          class="question-right content-text comment-text"
                        >
                          {{ item.data.liveChatMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="border-box">
                  <div
                    v-if="
                      promptMsg.operationType == 0 && promptMsg.busType == 2
                    "
                    class="whoCome"
                  >
                    <span class="whoCome_address">{{ promptMsg.address }}</span
                    >{{ decodeURI(promptMsg.data) }}来了
                  </div>
                  <div
                    class="text item"
                    v-for="(item, index) in msgList"
                    :key="index"
                    style="padding-right: 0px"
                    :style="{
                      'border-color':
                        item.busType == 1 ? 'transparent' : '#f1f1f1',
                    }"
                  >
                    <div
                      class="text-msg"
                      v-if="item.operationType == 0 && item.busType == 0"
                    >
                      <div class="avatar-img">
                        <img
                          :src="item.data.liveChatHeadimg || userinfo.headimg"
                          alt=""
                        />
                      </div>
                      <div class="zcrcalss">
                        <div class="user-name">
                          {{ item.data.liveChatName }}
                          <span
                            v-if="item.data.liveChatName == '主持人'"
                            class="user-info"
                            style="
                              background: #2a7ac3;
                              margin-right: 8px;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            >官方</span
                          ><span
                            style="
                              background: #ef983c;
                              color: rgba(255, 255, 255, 0.6);
                            "
                            class="user-info"
                            v-if="item.data.liveChatTopflag"
                            >置顶</span
                          >
                        </div>
                        <div class="createtime">
                          {{ item.data.createTime.slice(5) }}
                        </div>
                      </div>
                    </div>
                    <div class="twcontent" style="word-wrap: break-word">
                      <div class="question-box flex-between">
                        <div
                          v-if="item.operationType == 0 && item.busType !== 1"
                          class="question-right content-text comment-text"
                        >
                          {{ item.data.liveChatMessage }}
                        </div>
                        <div class="gift-msg" v-if="item.busType == 1">
                          <div class="gift-word">
                            <span>{{ item.data.liveChatName }}</span
                            >送出{{ item.data.liveChatGiftcount }}个{{
                              item.data.liveChatMessage
                            }}
                          </div>
                          <div
                            class="gift-img"
                            v-if="item.data.liveChatGiftimg"
                          >
                            <img
                              :src="item.data.liveChatGiftimg"
                              :alt="item.data.liveChatMessage"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </template>
        </div>
        <div
          v-else
          :style="{ height: tableHeight - 20 + 'px' }"
          style="height: 100%; position: relative"
        >
          <img
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            :src="require('@/assets/zsLiveImage/emptyH5.png')"
            alt=""
          />
        </div>
        <div class="question-msg-input">
          <div class="character-info">
            <div class="character">
              <div class="avatar-img">
                <img :src="userinfo.headimg" alt="" />
              </div>
            </div>
            <div class="character-send-content">
              <el-input
                v-model="msg"
                placeholder="请输入内容"
                maxlength="200"
                @keydown.enter.native="sendMsg"
                size="mini"
                v-if="liveUser.token"
              >
              </el-input>
              <div class="video-login-tip" v-else>
                <span
                  style="color: #3d7ddc; cursor: pointer"
                  @click.stop="handleClickNeedLogin"
                  >登录</span
                >后可以参与直播互动
              </div>
              <div class="character-send-actions">
                <!-- <div class="character-send-actions-emoji">
                          <img src="@/assets/zsLiveImage/emoji.png" alt="" />
                        </div> -->
                <div class="character-send-actions-send" @click="sendMsg">
                  <img src="@/assets/zsLiveImage/video-send.png" alt="" />
                </div>
              </div>
            </div>
            <div
              class="gift-box"
              v-if="activeName == '0' && liveDataInfo.liveRewardSwitch == 1"
            >
              <el-popover placement="top-end" width="290" trigger="click">
                <div class="gift-list">
                  <div
                    class="gift-item"
                    v-for="(item, index) in giftListSend"
                    :key="index"
                  >
                    <div
                      class="gift-card"
                      @click="getItem(item)"
                      :class="onPut == item ? 'gift-active' : 'gift-card'"
                    >
                      <div class="gift-img">
                        <img :src="getImagePathFunc(item)" />
                      </div>
                      <div class="gift-price">￥{{ item.livePropPrice }}</div>
                    </div>
                    <div class="gift-name" style="cursor: pointer">
                      {{ item.livePropName }}
                    </div>
                  </div>
                </div>
                <div class="gift-button">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      width: 200px;
                      height: 60px;
                    "
                  >
                    <div
                      style="
                        margin-right: 8px;
                        color: #3e3e49;
                        font-weight: bold;
                      "
                    >
                      ￥{{ returnFloat(giftRmb) }}元
                    </div>
                    <el-select
                      v-model="giftNum"
                      placeholder=""
                      size="mini"
                      style="width: 70px !important"
                      filterable
                      @change="giftSelectChange"
                    >
                      <el-option
                        v-for="item in giftOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="giveGift"
                    :disabled="!onPut"
                    >赠送</el-button
                  >
                </div>
                <div slot="reference">
                  <img src="@/assets/zsLiveImage/gift.png" alt="礼物" />
                </div>
              </el-popover>
            </div>
            <!-- 点赞 -->
            <div
              class="likeBox"
              id="likeBox"
              v-if="liveDataInfo.liveLikeSwitch"
              @click="$debounce(changeLikeNum, 200)"
            >
              <img
                style="width: 30px; height: 30px"
                :src="
                  likeShow
                    ? require('@/assets/zsLiveImage/bluedz.png')
                    : require('@/assets/zsLiveImage/dianzan.png')
                "
                alt=""
                @click="likeHeart"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图文直播 -->
    <div class="tab-content" v-if="activeName === '2'">
      <div
        class="ev-detail-cont-commen"
        :style="{ height: tableHeight - 20 + 'px' }"
      >
        <div
          class="comment-list"
          v-if="twzblist.length > 0 || topList.length > 0"
          style="height: 100%"
        >
          <template>
            <div class="answer-twzb">
              <el-card class="box-card" shadow="never">
                <div v-if="topList.length > 0" class="twzb-border-box">
                  <div
                    v-for="(item, index) in topList"
                    :key="index"
                    class="text item"
                  >
                    <div class="twzb-msg">
                      <div class="text-msg">
                        <div class="avatar-img">
                          <img
                            :src="
                              item.data.liveChatHeadimg ||
                              require('@/assets/zsLiveImage/zcr.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="zcrcalss">
                          <div class="zcrcalss-userInfo">
                            <div>
                              <span
                                class="user-name"
                                style="font-weight: bold"
                                >{{ item.data.name }}</span
                              >
                              <span
                                class="topping"
                                style="
                                  display: inline-block;
                                  width: 36px;
                                  font-size: 12px;
                                  height: 18px;
                                  text-align: center;
                                  color: #fff;
                                  line-height: 17px;
                                  border-radius: 6px;
                                  background-color: #f83939;
                                  margin-left: 7px;
                                "
                                >置顶</span
                              >
                            </div>
                            <div>
                              <span class="createtime">{{
                                item.data.createtime
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="zcrcalss-twzb">
                        <div
                          v-if="item.data.word != null"
                          class="twcontent"
                          style="word-wrap: break-word; font-size: 14px"
                        >
                          {{ item.data.word }}
                        </div>
                        <div
                          v-if="item.data.message.twzbimagelist.length > 0"
                          class="twcontent_image_list"
                        >
                          <el-image
                            class="twcontent_image_list_image"
                            v-for="(res, index) in item.data.message
                              .twzbimagelist"
                            :key="index"
                            :src="getFilePath(res.fileId)"
                            :preview-src-list="
                              getImageList(item.data.message.twzbimagelist)
                            "
                          ></el-image>
                        </div>
                        <div
                          v-if="item.data.message.twzbvideolist.length > 0"
                          class="twcontent"
                        >
                          <div
                            v-for="(dev, index) in item.data.message
                              .twzbvideolist"
                            :key="index"
                          >
                            <video width="250" height="141" controls>
                              <source
                                :src="getFilePath(dev.fileId)"
                                type="video/mp4"
                              />
                            </video>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="twzblist.length > 0" class="twzb-border-box">
                  <div
                    v-for="(item, index) in twzblist"
                    :key="index"
                    class="text item"
                  >
                    <div class="twzb-msg">
                      <div class="text-msg">
                        <div class="avatar-img">
                          <img
                            :src="
                              item.data.liveChatHeadimg ||
                              require('@/assets/zsLiveImage/zcr.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="zcrcalss">
                          <div class="zcrcalss-userInfo">
                            <span class="user-name">{{ item.data.name }}</span>
                            <div>
                              <span class="createtime">{{
                                item.data.createtime
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="zcrcalss-twzb">
                        <div
                          v-if="item.data.word != null"
                          class="twcontent"
                          style="word-wrap: break-word; font-size: 14px"
                        >
                          {{ item.data.word }}
                        </div>
                        <div
                          v-if="item.data.message.twzbimagelist.length > 0"
                          class="twcontent_image_list"
                        >
                          <el-image
                            v-for="(res, index) in item.data.message
                              .twzbimagelist"
                            :key="index"
                            class="twcontent_image_list_image"
                            :src="getFilePath(res.fileId)"
                            :preview-src-list="
                              getImageList(item.data.message.twzbimagelist)
                            "
                          ></el-image>
                        </div>
                        <div
                          v-if="item.data.message.twzbvideolist.length > 0"
                          class="twcontent"
                        >
                          <div
                            v-for="(dev, index) in item.data.message
                              .twzbvideolist"
                            :key="index"
                          >
                            <video width="250" height="141" controls>
                              <source
                                :src="getFilePath(dev.fileId)"
                                type="video/mp4"
                              />
                            </video>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </template>
        </div>
        <div
          v-if="topList.length == 0 && twzblist.length == 0"
          style="height: 100%; position: relative"
        >
          <img
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            :src="require('@/assets/zsLiveImage/emptyH5.png')"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 互动问答 -->
    <div class="tab-content" v-if="activeName === '3'">
      <div class="ev-detail-cont-commen">
        <div class="comment-list" :style="{ height: tableHeight - 20 + 'px' }">
          <template>
            <div class="twzb answer-twzb" style="height: 100%">
              <el-card
                class="box-card"
                v-if="questionList.length > 0 || topList.length > 0"
              >
                <div class="qa-border-box">
                  <div class="top-list" v-if="topList.length > 0">
                    <div
                      class="text item"
                      v-for="(item, index) in topList"
                      :key="index"
                      v-if="item.data.flag == 1"
                      style="
                        padding-bottom: 16px;
                        margin-bottom: 17px;
                        border-bottom: 1px solid rgb(241, 241, 241);
                      "
                    >
                      <div class="text-msg">
                        <div class="avatar-img">
                          <img
                            :src="item.data.headimg || userinfo.headimg"
                            alt=""
                          />
                        </div>
                        <div class="zcrcalss">
                          <div class="user-info">
                            <div class="user-name">
                              {{ item.data.name }}
                              <span
                                class="user-info"
                                style="
                                  background: #2a7ac3;
                                  margin-right: 8px;
                                  color: rgba(255, 255, 255, 0.6);
                                "
                                v-if="item.data.name == '主持人'"
                                >官方</span
                              ><span
                                style="
                                  background: #ef983c;
                                  color: rgba(255, 255, 255, 0.6);
                                "
                                class="user-info"
                                >置顶</span
                              >
                              <div class="right-btn">
                                <el-badge
                                  :value="item.data.liveActivityqaAgreecountNum"
                                  class="item"
                                >
                                  <div
                                    style="margin-right: 10px"
                                    v-if="item.data.Enter"
                                    @click="unSetProblem(item, index, 'top')"
                                  >
                                    同问
                                  </div>
                                  <div
                                    style="margin-right: 10px"
                                    v-else
                                    @click="setProblem(item, index, 'top')"
                                  >
                                    同问
                                  </div>
                                </el-badge>
                              </div>
                            </div>
                            <div>
                              <div class="createtime">
                                {{ item.data.createtime }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="twcontent" style="word-wrap: break-word">
                        <div class="question-box flex-between">
                          <div class="question-left content-icon">
                            <img
                              src="@/assets/zsLiveImage/qa_wen.png"
                              alt="问"
                            />
                          </div>
                          <div class="question-right content-text">
                            {{ item.data.message }}
                          </div>
                        </div>
                        <div class="answer-box" v-if="item.data.flag == 1">
                          <div
                            class="answer-box"
                            v-for="(arr, ind) in item.data.data"
                            :key="ind"
                          >
                            <div class="text-msg" style="margin-left: 30px">
                              <div>
                                <div class="avatar-img">
                                  <img
                                    :src="arr.headimg || userinfo.headimg"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="zcrcalss">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                  "
                                >
                                  <div style="">
                                    <span
                                      style="font-size: 14px; font-weight: bold"
                                      >{{ arr.name }}</span
                                    >
                                    <div style="margin-top: 0px">
                                      <span
                                        style="font-size: 12px; color: #999"
                                      >
                                        {{ arr.createtime }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex-between"
                              style="
                                margin-left: 36px;
                                display: flex;
                                margin-top: 5px;
                              "
                            >
                              <div
                                class="answer-left content-icon"
                                style="margin-right: 8px"
                              >
                                <img
                                  :src="
                                    require('@/assets/zsLiveImage/qa_da.png')
                                  "
                                  alt=""
                                />
                              </div>
                              <div class="answer-right content-text">
                                {{ arr.message }}
                              </div>
                            </div>
                            <!-- <div class="operation">
                                      <span class="time">
                                        {{ arr.createtime }}
                                      </span>
                                      <el-link
                                        type="danger"
                                        :underline="false"
                                        @click="Delete(arr.messageid, 'qa')"
                                        style="font-size: 12px;"
                                        >删除</el-link
                                      >
                                    </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="untop-list" v-if="questionList.length > 0">
                    <div
                      class="text item"
                      v-for="(item, index) in questionList"
                      :key="index"
                      style="
                        padding-bottom: 16px;
                        margin-bottom: 17px;
                        border-bottom: 1px solid #f1f1f1;
                      "
                    >
                      <div class="text-msg">
                        <div class="avatar-img">
                          <img
                            :src="item.data.headimg || userinfo.headimg"
                            alt=""
                          />
                        </div>
                        <div class="zcrcalss">
                          <div class="user-info">
                            <div class="user-name">
                              {{ item.data.name }}
                              <span
                                class="user-info"
                                style="
                                  background: #2a7ac3;
                                  margin-right: 8px;
                                  color: rgba(255, 255, 255, 0.6);
                                "
                                v-if="item.data.name == '主持人'"
                                >官方</span
                              >
                              <div class="right-btn">
                                <el-badge
                                  :value="item.data.liveActivityqaAgreecountNum"
                                  class="item"
                                >
                                  <div
                                    style="margin-right: 10px; cursor: pointer"
                                    v-if="item.data.Enter"
                                    @click="unSetProblem(item, index, 'untop')"
                                  >
                                    同问
                                  </div>
                                  <div
                                    style="margin-right: 10px; cursor: pointer"
                                    v-else
                                    @click="setProblem(item, index, 'untop')"
                                  >
                                    同问
                                  </div>
                                </el-badge>
                              </div>
                            </div>
                            <div>
                              <div class="createtime">
                                {{ item.data.createtime }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="twcontent" style="word-wrap: break-word">
                        <div class="question-box flex-between">
                          <div class="question-left content-icon">
                            <img
                              :src="require('@/assets/zsLiveImage/qa_wen.png')"
                              alt="问"
                            />
                          </div>
                          <div class="question-right content-text">
                            {{ item.data.message }}
                          </div>
                        </div>
                        <div class="answer-box" v-if="item.data.flag == 1">
                          <div
                            class="answer-box"
                            v-for="(arr, ind) in item.data.data"
                            :key="ind"
                          >
                            <div class="text-msg" style="margin-left: 30px">
                              <div>
                                <div class="avatar-img">
                                  <img
                                    :src="arr.headimg || userinfo.headimg"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div class="zcrcalss">
                                <div
                                  style="
                                    display: flex;
                                    justify-content: space-between;
                                  "
                                >
                                  <div style="">
                                    <span
                                      style="font-size: 14px; font-weight: bold"
                                      >{{ arr.name }}</span
                                    >
                                    <div style="margin-top: 0px">
                                      <span
                                        style="font-size: 12px; color: #999"
                                      >
                                        {{ arr.createtime }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="flex-between"
                              style="
                                margin-left: 36px;
                                display: flex;
                                margin-top: 5px;
                              "
                            >
                              <div
                                class="answer-left content-icon"
                                style="margin-right: 8px"
                              >
                                <img
                                  :src="
                                    require('@/assets/zsLiveImage/qa_da.png')
                                  "
                                  alt=""
                                />
                              </div>
                              <div class="answer-right content-text">
                                {{ arr.message }}
                              </div>
                            </div>
                            <!-- <div class="operation">
                                      <span class="time">
                                        {{ arr.createtime }}
                                      </span>
                                      <el-link
                                        type="danger"
                                        :underline="false"
                                        @click="Delete(arr.messageid, 'qa')"
                                        style="font-size: 12px;"
                                        >删除</el-link
                                      >
                                    </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-card>
              <div
                v-if="topList.length == 0 && questionList.length == 0"
                style="height: 100%; position: relative"
              >
                <img
                  style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                  "
                  :src="require('@/assets/zsLiveImage/emptyH5.png')"
                  alt=""
                />
              </div>
            </div>
          </template>
        </div>
        <div class="question-msg-input">
          <div class="character-info">
            <div class="character">
              <div class="avatar-img">
                <img :src="userinfo.headimg" alt="" />
              </div>
            </div>
            <div class="character-send-content">
              <el-input
                v-model="problem"
                placeholder="请输入内容"
                maxlength="200"
                @keydown.enter.native="questions"
                v-if="token"
                size="mini"
              >
              </el-input>
              <div class="video-login-tip" v-else>
                <span
                  style="color: #3d7ddc; cursor: pointer"
                  @click.stop="handleClickNeedLogin"
                  >登录</span
                >后可以参与直播互动
              </div>
              <div class="character-send-actions">
                <!-- <div class="character-send-actions-emoji">
                          <img src="@/assets/zsLiveImage/emoji.png" alt="" />
                        </div> -->
                <div class="character-send-actions-send" @click="questions">
                  <img src="@/assets/zsLiveImage/video-send.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 边看边买 -->
    <div
      class="tab-content"
      v-if="activeName === '4'"
      style="overflow-y: auto"
      :style="{ height: tableHeight - 20 + 'px' }"
    >
      <div class="newmenu-content comment-list" v-if="commodityList.length > 0">
        <div
          class="newmenu-content-buy-item"
          v-for="(item, ind) in commodityList"
          :key="ind"
        >
          <div class="newmenu-content-buy-item">
            <img
              :src="item.liveActivityBuyImg"
              alt=""
              style="width: 100%; height: 100%; object-fit: cover"
            />
          </div>
          <div class="newmenu-content-buy-item-right-content">
            <div class="newmenu-content-buy-item-right-content-title">
              {{ item.liveActivityBuyTitle }}
            </div>
            <div class="newmenu-content-buy-item-right-content-btn">
              <span class="buy-price">¥{{ item.liveActivityBuyPrice }}</span>
              <span class="buy-btn" @click="openUrl(item.liveActivityBuyLink)"
                >立即购买</span
              >
            </div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background: #f1f1f1;
            width: 100%;
            margin-top: 15px;
          "
        ></div>
      </div>
      <div
        v-else
        class="newmenu-content comment-list"
        :style="{ height: tableHeight - 110 + 'px' }"
      >
        <div
          class="uncontent-box"
          style="width: 100%; height: 100%; position: relative"
        >
          <img
            :src="require('@/assets/zsLiveImage/emptyH5.png')"
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 直播推荐 -->
    <div
      class="tab-content"
      v-if="activeName === '5'"
      style="overflow-y: auto"
      :style="{ height: tableHeight - 20 + 'px' }"
    >
      <div class="recommendList-content" v-if="recommendList.length > 0">
        <div
          class="recommendList-content-item"
          v-for="(item, ind) in recommendList"
          :key="ind"
          @click="openTextUrl(item)"
        >
          <div class="recommendList-content-item-left-img">
            <img :src="getPerviewImg(item.liveActivityRecommendImg)" alt="" />
          </div>
          <div class="recommendList-content-item-right-content">
            <div class="recommendList-item-title">
              {{ item.liveActivityRecommendTitle }}
            </div>
            <div class="recommendList-item-time">
              {{ item.liveActivityRecommendPublishTime }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="newmenu-content"
        :style="{ height: tableHeight - 110 + 'px' }"
      >
        <div
          class="uncontent-box"
          style="width: 100%; height: 100%; position: relative"
        >
          <img
            :src="require('@/assets/zsLiveImage/emptyH5.png')"
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 活动简介 -->
    <div
      class="ev-detail-cont-commen tab-content"
      v-if="activeName === '1'"
      :style="{ height: tableHeight - 50 + 'px' }"
    >
      <div
        class="newmenu-content"
        v-if="synopsis[0].liveMenuContent"
        style="padding: 10px 15px 0 15px"
      >
        <div class="content-text" v-html="synopsis[0].liveMenuContent"></div>
      </div>
      <div
        v-else
        class="newmenu-content"
        :style="{ height: tableHeight - 110 + 'px' }"
      >
        <div
          class="uncontent-box"
          style="width: 100%; height: 100%; position: relative"
        >
          <img
            :src="require('@/assets/zsLiveImage/emptyH5.png')"
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 160px;
              height: 200px;
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 节目单 -->
    <div class="tab-content" v-if="activeName === '7'">
      <div class="date-items">
        <el-tabs v-model="editableTabsValue" type="card">
          <el-tab-pane v-for="(item, ind) in dateList" :key="ind">
            <div class="day" slot="label" @click="tabclick(item)">
              <div>{{ item.time.slice(5) }}</div>
              <div class="day-detail">{{ item.day }}</div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <zsTable
        :column="column"
        :show-header="false"
        ref="elTable"
        height="400"
        :data="tableData"
        :showPagination="false"
      >
        <template #startTime="{ scope }">
          <span style="color: #9b9dad"> {{ scope.startTime }}</span>
        </template>
        <template #liveProgramName="{ scope }">
          <p
            :title="scope.liveProgramName"
            style="
              color: #9b9dad;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ scope.liveProgramName }}
          </p>
        </template>
        <template #action="{ scope }">
          <div>
            <el-link
              v-if="
                scope.playbackFlag == 1 &&
                new Date(
                  scope.livePlayDay.replace(
                    /^(\d{4})(\d{2})(\d{2})$/,
                    '$1-$2-$3'
                  )
                ).getTime() +
                  scope.liveProgramTimeLength * 1000 <
                  Date.now() &&
                !scope.clicked
              "
              :underline="false"
              type="info"
              @click="replay(scope)"
            >
              <span style="color: #9b9dad"> 回看 </span>
            </el-link>
            <el-link
              v-if="
                new Date(
                  scope.livePlayDay.replace(
                    /^(\d{4})(\d{2})(\d{2})$/,
                    '$1-$2-$3'
                  )
                ).getTime() +
                  scope.liveProgramTimeLength * 1000 >
                  Date.now() &&
                new Date(
                  scope.livePlayDay.replace(
                    /^(\d{4})(\d{2})(\d{2})$/,
                    '$1-$2-$3'
                  )
                ).getTime() < Date.now()
              "
              type="warning"
              :underline="false"
              >回看中</el-link
            >
            <el-link
              type="primary"
              :underline="false"
              v-if="
                playing(scope.livePlayTime, scope.liveProgramTimeLength) &&
                !liveFlag
              "
              @click="showLive(scope)"
            >
              <span style="color: #4788f3">直播中</span>
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              v-if="
                playing(scope.livePlayTime, scope.liveProgramTimeLength) &&
                liveFlag
              "
              @click="showLive(scope)"
            >
              直播
            </el-link>
          </div>
        </template>
      </zsTable>
    </div>
    <!-- 右侧分享回复 -->
    <div class="tabsRight">
      <div class="share" @click="shareWx" >
      <!-- <div class="share" @click="shareWx" v-if="appOrh5Share()"> -->
        <img src="@/assets/zsLiveImage/h5/share.png" alt="" style="width: 62px;height:62px"/>
      </div>
      <div class="replay" v-if="activeName == 6" @click="replayMsg">
        <img src="@/assets/zsLiveImage/h5/msg.png" alt="" style="width: 62px;height:62px"/>
      </div>
    </div>
    <!-- 回复输入框 -->
    <div class="replayDetailsBox" v-if="replayShow && activeName == 6"  @click.stop="replayShow = false">
      <div class="replayDetails" @click.stop="replayShow= true">
        <div class="userHeaderImg">
          <img :src="userinfo.headimg" alt="" />
        </div>
        <div class="replayInput">
          <el-input
            type="textarea"
            v-model="msg"
            @blur="inputBlur"
            :rows="2"
            placeholder="请输入内容"
            maxlength="200"
            @focus="focusIn" 
            id="#CommentContent"
            @keydown.enter.native="sendMsg"
            size="mini"
          >
          </el-input>
          <!-- <div class="video-login-tip" v-else>
            <span
              style="color: #3d7ddc; cursor: pointer"
              @click.stop="handleClickNeedLogin"
              >登录</span
            >后可以参与直播互动
          </div> -->
        </div>
        <div class="replayBtn" @click="sendMsg">发送</div>
      </div>
    </div>

    <!-- 登录 -->
    <el-dialog
      :visible.sync="needLoginVisible"
      width="400px"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      custom-class="my_login_dialog"
    >
      <!-- <img src="#" alt=""> -->
      <div slot="title" class="my_login_title">
        <div class="my_login_title_toogle">
          <div class="my_login_title_toogle_image">
            <img
              @click="handleChangeLoginType(2)"
              v-if="loginType != 2"
              src="@/assets/zsLiveImage/login/toggleLogin.png"
              alt=""
            />
            <img
              @click="handleChangeLoginType(0)"
              v-else
              src="@/assets/zsLiveImage/login/toggleLogin_mobile.png"
              alt=""
            />
            <img
              @click="handleChangeLoginType(2)"
              v-if="loginType != 2"
              src="@/assets/zsLiveImage/login/toggleLogin_tip.png"
              alt=""
            />
            <img
              @click="handleChangeLoginType(0)"
              v-else
              src="@/assets/zsLiveImage/login/toggleLogin_mobile_tip.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="my_login_content" v-if="loginType == 1 || loginType == 0">
        <div class="my_login_content_header">
          <div
            class="my_login_content_header_item"
            @click="handleChangeLoginType(0)"
            :class="{ my_login_content_header_item_selected: loginType == 0 }"
          >
            短信登录
          </div>
          <div
            class="my_login_content_header_item"
            :class="{ my_login_content_header_item_selected: loginType == 1 }"
            @click="handleChangeLoginType(1)"
          >
            密码登录
          </div>
          <!-- 区分登录类型  0 手机验证码登录，1 用户密码登录， 2扫码登陆 3 微信扫码登录 -->
        </div>
        <div class="my_login_content_form">
          <!-- 手机验证码登录  ---------- 手机号 -->
          <div class="my_login_content_form_item" v-if="loginType == 0">
            <el-input placeholder="请输入手机号" v-model="loginForm.phone">
              <svg-icon
                icon-class="phone_live_login"
                class-name="login_svg_item"
                slot="prefix"
              />
            </el-input>
          </div>
          <!-- 手机验证码登录  ---------- 验证码 -->
          <div class="my_login_content_form_item" v-if="loginType == 0">
            <el-input placeholder="请输入验证码" v-model="loginForm.smsCode">
              <svg-icon
                icon-class="safe_live_login"
                class-name="login_svg_item"
                slot="prefix"
              />
            </el-input>
            <div
              class="my_login_content_form_item_code_btn"
              @click="sendMsgForLogin"
            >
              {{ msgBtn }}
            </div>
          </div>
          <!-- 账号密码登录  ------------账号 -->
          <div class="my_login_content_form_item" v-if="loginType == 1">
            <el-input
              placeholder="请输入账号/手机号"
              v-model="loginForm.account"
            >
              <svg-icon
                icon-class="phone_live_login"
                class-name="login_svg_item"
                slot="prefix"
              />
            </el-input>
          </div>
          <!-- 账号密码登录  ------------密码 -->
          <div class="my_login_content_form_item" v-if="loginType == 1">
            <el-input
              placeholder="请输入密码"
              type="password"
              v-model="loginForm.password"
            >
              <svg-icon
                icon-class="safe_live_login"
                class-name="login_svg_item"
                slot="prefix"
              />
            </el-input>
          </div>

          <div class="my_login_content_form_action">
            <el-button
              type="primary"
              style="width: 100%"
              @click="handleSubmitLogin"
              >登录</el-button
            >
          </div>
          <div class="my_login_content_form_user">
            <el-checkbox v-model="privacy"
              >我已同意并阅读<span @click.stop="() => {}">《用户协议》</span
              ><span>《隐私政策》</span></el-checkbox
            >
          </div>
          <div class="my_login_content_third_count">
            <div
              class="my_login_content_third_item my_login_content_third_item_qq"
            ></div>
            <div
              class="my_login_content_third_item my_login_content_third_item_weibo"
            ></div>
            <div
              @click="handleClickThirdLogin(3)"
              class="my_login_content_third_item my_login_content_third_item_weixin"
            ></div>
          </div>
        </div>
      </div>
      <div class="my_login_content" v-if="loginType == 2">
        <div class="my_login_content_Qrcode_title">手机扫码登录</div>
        <div class="my_login_content_qrcode_content">
          <canvas
            width="148"
            height="148"
            class="loginForQrcode"
            ref="loginForQrcode"
          ></canvas>
          <div class="qrCodeTryAgagin" v-if="appQrcodeTry">
            <i
              @click="initQrCodeImage"
              class="my_qrCodeTryAgagin_button el-icon-refresh-right"
            ></i>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 赠送礼物支付 -->
    <el-dialog
      title="待支付"
      custom-class="pay_dialog"
      :visible.sync="payment"
      center
      :close-on-press-escape="true"
      :fullscreen="true"
      :close-on-click-modal="false"
      @close="payClose"
    >
      <div v-if="isPay == 0" class="to-paid">
        <div
          id="payQrcode"
          ref="payQrcode"
          style="
            margin: 63px 52px;
            width: 180px;
            height: 180px;
            overflow: hidden;
          "
        ></div>
      </div>

      <!-- 支付成功or失败 -->
      <div v-if="isPay != 0" class="payment to-paid">
        <img :src="payImg" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { menuQuery } from "@/api/cloudLive/liveMenu";
import { activitybuyPage } from "@/api/cloudLive/activityBuy";
import {
  smsManager,
  userManagerWebLogin,
  userManagerWebLoginByAccount,
  getLoginQrcode,
  timeOutGetCode,
} from "@/api/tenantUser.js";
import {
  activityDetailNotoken,
  activityLike,
  forbiddenuserAddCount,
  forbiddenuserMinuscount,
} from "@/api/liveView/activity.js";
import { appOrh5Login,appShare ,appOrh5Share,getLoginStatus} from "@/utils/app";
import { filePerviewPath } from "@/api/globalApi.js";
import { atoncePay, getOrder } from "@/api/recharge/recharge";
import QRCode2 from "qrcodejs2";
import { mapMutations } from "vuex";
import { Toast } from "vant";
import axios from "@/utils/request.js";
import {
  configurationGroup,
  configurationManagerSingle,
} from "@/api/common.js";
export default {
  data() {
    return {
      activeName: "1", // 默认tab选项
      editableTabs: [], // 数据表格
      editableTabsValue: "",
      msgList: [], // 评论列表
      userinfo: {
        headimg: require("@/assets/zsLiveImage/h5/headerImg.png"),
        userName:
          "游客" + Date.parse(new Date()) + Math.round(Math.random() * 100),
        origin: "web",
        userId: "",
      },
      liveUser: JSON.parse(window.localStorage.getItem("userinfo")) || {},
      sendMsgobj: {}, // 评论区信息
      sendtwzbobj: {}, // 图文直播信息
      sendqaobj: {}, // 互动问答信息
      originType: false,
      needLoginVisible: false,
      loginForm: {
        //登录表单
      },
      msg: "", // 聊天输入框
      privacy: 0, //用户隐私协议等  选择框
      msgBtn: "获取验证码", // 发送短信 文字提示 -----短信登录
      canSendMsg: true, // 是否可以发送短信----短信登录
      timer: null, // 倒计时定时器----短信登录
      count: 0, //倒计时时间 -----短信登录
      loginType: 0, // 区分登录类型  0 手机验证码登录，1 用户密码登录， 2扫码登陆 3 微信扫码登录
      tvId: 0, // id
      tvType: 5, // 类型
      msgList: [], // 评论列表
      topList: [], //置顶信息
      synopsis: [], // 活动简介
      twzblist: [], // 图文直播列表
      questionList: [], // 提问列表
      applyList: [], // 回复列表
      giftList: [], // 礼物列表
      giftListSend: [], // 赠送礼物列表
      likeShow: false, // 点赞
      addLikeNum: 0, // 点赞数
      likeTimer: "", // 定时器
      messageData: {}, // socket信息
      promptMsg: {},
      problem: "", // 提问内容
      forbiddenData: [], // 禁言名单数据
      giftRmb: 0.0, // 礼物金额
      giftOptions: [], // 礼物数量
      giftNum: null, // 赠送礼物数量
      onPut: "", // 礼物选中
      commodityList: [], // 商品列表
      recommendList: [], // 推荐列表
      payment: false, // 支付弹框
      isPay: 0, // 0 待支付 1 支付成功 2 支付失败
      payImg: "",
      userLoginStatus: "", //登录态
      replayShow: false, // 回复弹框显隐
      // 获取图片的 路径前缀
      myPicPath: "",
      appIsShow:false,
    };
  },
  props: {
    liveDataInfo: {
      type: Object,
      default: {},
    },
    giftListSend: {
      type: Array,
      default: [],
    },
    videoBoxHeight:{
      type:Number,
      default:0,
    }
  },
  computed: {
    getWsMsg() {
      //在核心代码接收到的服务端信息存储到vuex的属性
      return this.$store.state.webSocketMsg;
    },
    tableHeight() {
      this.clientWidth = document.body.clientWidth;
      console.log(this.clientWidth);
      let tableHeight = window.innerHeight - this.videoBoxHeight;

      if (tableHeight < 0) {
        return 0;
      } else {
        return tableHeight;
      }
    },
  },
  watch: {
    // 监听onmessage数据赋值到展示
    getWsMsg(data, val) {
      this.messageData = JSON.parse(data);
      console.log(this.messageData);
      if (this.activeName == "6") {
        if (this.messageData.auditing.length > 0) {
          Toast("评论已提交审核");
        }
      }
      if (this.activeName == "0") {
        this.msgList = this.messageData.questionList.slice().reverse();
        if (this.messageData.questionList) {
          this.msgList = this.messageData.questionList.slice().reverse();
        }
        this.giftList = this.messageData.giftList;
        if (this.messageData.tipsList.length > 0) {
          this.promptMsg = this.messageData.tipsList[0];
          setTimeout(() => {
            this.promptMsg = {};
          }, 2000);
        }
      } else if (this.activeName == "2") {
        if (this.messageData.questionList) {
          this.twzblist = this.messageData.questionList;
        }
        if (this.messageData.topList) {
          this.topList = this.messageData.topList;
        }
      } else if (this.activeName == "3") {
        if (this.messageData.questionList) {
          this.questionList = this.messageData.questionList.slice().reverse();
        }
        if (this.messageData.topList) {
          this.topList = this.messageData.topList;
        }
      } else if (this.activeName == "6") {
        this.msgList = this.messageData.questionList.slice().reverse();
        this.topList = this.messageData.topList;
        // if (this.messageData.questionList) {
        //   this.msgList = this.messageData.questionList.slice().reverse();
        // }
        this.giftList = this.messageData.giftList;
        if (this.messageData.tipsList.length > 0) {
          this.promptMsg = this.messageData.tipsList[0];
          setTimeout(() => {
            this.promptMsg = {};
          }, 2000);
        }
      }
      this.giftList = this.messageData.giftList;
      if (this.messageData.tipsList) {
        // this.msgList.unshift(this.messageData.tipsList[0]);
      }
      // console.log(this.msgList)
    },
    tvLivetime(value) {
      if (value < 0) {
        // this.livePwState=1
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    interval(value) {
      if (!value) {
        this.getList(this.tvId);
      }
    },
    liveUser(val){
      console.log(val);
    }
  },
  mounted() {
    this.$bus.$on('isLogin',(data)=>{
      if(data==1){
        if(this.appOrh5Share() && sessionStorage.getItem('userinfo')){
          let appUserInfo = JSON.parse(JSON.parse(sessionStorage.getItem('userinfo'))).data||{}
          let obj={
            headimg:appUserInfo.userHeadPath || require("@/assets/zsLiveImage/h5/headerImg.png"),
            webUserMobile:appUserInfo.userPhone ? appUserInfo.userPhone : appUserInfo.webUserMobile,
            token:appUserInfo.token,
            webUserAccount:appUserInfo.webUserAccount,
            userName:appUserInfo.userNick ? appUserInfo.userNick : appUserInfo.webUserName,
            userId:appUserInfo.userId
          }
          this.liveUser = obj
          this.userinfo = obj
        }
        // location.reload()
      }
    })

    // 访问来源判断
    this.setGiftNum();
    this.tvId = this.$route.query.tvid;
    if (this.$route.query.tvType > 5) {
      if (this.$route.query.tvType == 6) {
        this.tvType = 1;
      } else if (this.$route.query.tvType == 7) {
        this.tvType = 2;
      } else if (this.$route.query.tvType == 8) {
        this.tvType = 5;
      } else if (this.$route.query.tvType == 10) {
        this.tvType = 3;
      } else if (this.$route.query.tvType == 16) {
        this.tvType = 4;
      }
    } else {
      this.tvType = this.$route.query.tvType;
    }
    this.getMenuList(this.tvId, this.tvType);
    let webTenId = this.$route.query.webTenId;
    localStorage.setItem("webTenId", webTenId);
    if (this.$route.query.originType) {
      let cmsToken = this.$route.query.token;
      if (cmsToken) {
        localStorage.setItem("onlyUseByCmsToken", cmsToken);
      }
    }
    window.onresize = () => {
      this.clientWidth = document.body.clientWidth;
    };
    window.onload = function () {
      var isPageHide = false;
      // 页面加载（是没有刷新页面的，跟页面刷新有着本质的不同）
      window.addEventListener("pageshow", function () {
        if (isPageHide) {
          window.location.reload();
        }
      });
      window.addEventListener("pagehide", function () {
        isPageHide = true;
      });
    };

    // iscms 判断是否在cms中 
    // iscmsLogin 判断cms是否登录
    // this.originType = this.$route.query.originType;
    // // let showlocal = localStorage.getItem("cmsUserId");
    // if (this.originType) {
    //   // 判断是否在cms
    //   // this.iscms = true;
    //   var showlocal = this.$route.query.token || null;
    //   console.log(!!showlocal);
    //   if (!!showlocal) {
    //     this.iscmsLogin = true;
    //     this.liveUser = {
    //       token: decodeURIComponent(this.$route.query.token),
    //       webUserName: this.$route.query.userName,
    //       headimg:
    //         decodeURIComponent(this.$route.query.imagePath) ||
    //         "https://news.zsvideo-data.com/defaultAvatar.png",
    //     };
    //     // web.get("/cms/user/findUser?userId=" + showlocal).then((res) => {
    //     //   if (res.data.status === 0) {
    //     //     let user = res.data.data;
    //     this.userinfo.userName = this.$route.query.userName;
    //     this.userinfo.headimg =
    //       this.$route.query.imagePath ||
    //       require("@/assets/zsLiveImage/zcr.png");
    //     this.userinfo.userId = this.$route.query.cmsUserId;
    //     //   }
    //     // });
    //     // 获取cms用户信息
    //   } else {
    //     this.userinfo.userName =
    //       "游客" + Date.parse(new Date()) + Math.round(Math.random() * 100);
    //     this.userinfo.headimg = require("@/assets/zsLiveImage/zcr.png");
    //     this.userinfo.userId =
    //       Date.parse(new Date()) + Math.round(Math.random() * 100);
    //   }
    // }
    this.getSetting();
    this.getCommodity();
    // 判断用户是否已登录
    if (this.liveUser && this.liveUser.token) {
      let picId= JSON.parse(localStorage.getItem('userinfo')).webUserAvatar
      let picture = this.getPerviewImg(picId)
      console.log(picture);
      var headimg = this.userinfo.headimg
        ? this.userinfo.headimg.charAt(0) == "/"
          ? "" + this.myPicPath + this.userinfo.headimg
          : this.userinfo.headimg
        : require("@/assets/zsLiveImage/video-user-avatar.png");
      this.userinfo = {
        headimg: this.liveUser.headimg || require("@/assets/zsLiveImage/h5/headerImg.png"),
        userName: this.liveUser.userName ? this.liveUser.userName : this.liveUser.webUserName,
        userId: this.liveUser.webUserId,
        origin: "web",
      };
    }
  },
  updated() {
    if (this.$refs.answerTwzb) {
      this.scrollToBottom();
    }
    
  },
  beforeDestroy() {
    clearInterval(this.likeTimer);
  },
  methods: {
    appOrh5Share,
    appShare,
    ...mapMutations(["setNeedLoginType"]),
    // 设置礼物数
    setGiftNum() {
      for (let i = 1; i < 100; i++) {
        this.giftOptions.push({ label: i, value: i });
      }
    },
    // 切换
    handleClick(ele) {
      this.activeName = String(ele);
      // this.msgList=[]
      if (this.$setWs.ws) {
        this.$setWs.ws.close();
        this.topList = [];
      }
      if (this.activeName == "0") {
        this.socketOpen("chat");
      } else if (this.activeName == "2") {
        this.socketOpen("live");
      } else if (this.activeName == "3") {
        this.answer = 2;
        this.socketOpen("qa");
      } else if (this.activeName == "4") {
        this.getCommodity(); // 商品
      } else if (this.activeName == "5") {
        this.getRecommend(); // 直播推荐
      } else if (this.activeName == "6") {
        this.socketOpen("comment");
      }
    },
    // 获取MenuList
    getMenuList(liveId, liveType) {
      menuQuery({ liveId, liveType }).then((res) => {
        if (res.data.code == 200) {
          console.log(this.activeName);
          // this.editableTabs = res.data.data;
          this.editableTabs = res.data.data.filter((item) => {
            return item;
          });
          if (this.editableTabs.length > 0) {
            this.editableTabs = this.editableTabs.filter((item) => {
              return item.rowStatus !== 0;
            });
            this.activeName = this.editableTabs[0].liveMenuType.toString();
            this.handleClick(this.activeName);
            this.editableTabs.forEach((item) => {
              if (item.liveMenuType === 1) {
                this.synopsis.push(item);
              }
            });
          } else {
            this.activeName = "1";
          }
        }
        // if (this.editableTabs.length==1) {
        // }
      });
    },
    // 发表评论
    sendMsg() {
      let type = "";
      if (this.activeName == "0") {
        type = "chat";
      } else if (this.activeName == "6") {
        type = "comment";
      } else if (this.activeName == "2") {
        type = "live";
      } else if (this.activeName == "3") {
        type = "qa";
      }

      // 当前是否为cms登录状态
      if (this.msg == "") {
        Toast("请输入内容");
      } else {
        this.sendMsgobj = {
          seq: this.setUuid(),
          type: type,
          chatType: this.tvType,
          data: {
            messagetype: "send",
            type: "send",
            userid: this.userinfo.userId,
            name: this.userinfo.userName,
            headimg: this.userinfo.headimg,
            liveId: this.tvId, //以后会去掉，现在还得传
            message: this.msg,
            word: this.msg,
          },
        };
        this.$setWs.ws.send(JSON.stringify(this.sendMsgobj));
        this.msg = "";
        setTimeout(() => {
          this.replayShow = false
          window.scroll(0, 0)
        }, 100);
        setTimeout(() => {
          this.scrollToBottom();
        }, 500);
      }
    },
    focusIn() {
      // ios键盘弹出底部留白问题
      const body = document.querySelector('#CommentContent') // input所在的容器
      body.scrollTop = body.scrollHeight
    },
    // 互动聊天登录按钮
    handleClickNeedLogin() {
      this.getMyLoginStatus();
    },
    // 查询已添加商品列表
    getCommodity() {
      activitybuyPage({ liveActivityId: this.tvId }).then((res) => {
        if (res.data.code === 200) {
          this.commodityList = res.data.data;
        }
      });
    },
    // 登录获取验证码
    sendMsgForLogin() {
      if (!this.loginForm.phone) {
        Toast("请输入手机号");
        return false;
      }
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/g;
      if (!this.loginForm.phone.match(reg)) {
        this.canSendMsg = false;
        Toast("请输入正确的手机号");
        return false;
      } else {
        this.canSendMsg = true;
      }

      if (!this.canSendMsg) return false;
      const TIME_COUNT = 60;
      this.count = TIME_COUNT;
      this.canSendMsg = false;
      let form = {
        webUserMobile: this.loginForm.phone,
        webTenId: this.$route.query.webTenId,
      };
      smsManager(form).then((res) => {
        if (res.data.code == 200) {
          Toast(res.data.msg);
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
              this.msgBtn = `重新获取(${this.count})`;
            } else {
              this.canSendMsg = true;
              clearInterval(this.timer);
              this.timer = null;
              this.msgBtn = "获取验证码";
            }
          }, 1000);
        } else {
          this.canSendMsg = true;
          clearInterval(this.timer);
          this.timer = null;
          this.msgBtn = "获取验证码";
        }
      });
    },
    // 登录
    handleSubmitLogin() {
      if (!this.privacy) {
        Toast("请同意并阅读用户协议和隐私政策");
        return false;
      }
      if (this.loginType == 0) {
        if (!this.loginForm.phone) {
          Toast("请输入手机号");
          return false;
        }
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/g;
        if (!this.loginForm.phone.match(reg)) {
          this.canSendMsg = false;
          Toast("请输入正确的手机号");
          return false;
        }
        if (!this.loginForm.smsCode) {
          Toast("请输入验证码");
          return false;
        }
        let form = {
          webUserMobile: this.loginForm.phone,
          webTenId: this.$route.query.webTenId,
          smsCode: this.loginForm.smsCode,
        };
        userManagerWebLogin(form).then((res) => {
          if (res.data.code == 200) {
            let user = res.data.data;
            this.needLoginVisible = false;
            res.data.data.headimg = res.data.data.webUserAvatarPath
              ? res.data.data.webUserAvatarPath.charAt(0) == "/"
                ? "" + this.myPicPath + res.data.data.webUserAvatarPath
                : this.liveUser.webUserAvatarPath
              : require("@/assets/zsLiveImage/zcr.png");
            this.userinfo = {
              headimg: res.data.data.headimg,
              userName: res.data.data.webUserName,
              userId: res.data.data.webUserId,
              origin: "web",
            };
            this.liveUser = res.data.data;
            window.localStorage.setItem("liveUser", JSON.stringify(user));
            window.localStorage.setItem("token", user.token);
            this.loginForm = {};
          }
        });
      } else if (this.loginType == 1) {
        if (!this.loginForm.account) {
          Toast("请输入账号/手机号");
          return false;
        }
        if (!this.loginForm.password) {
          Toast("请输入密码");
          return false;
        }
        let form = {
          account: this.loginForm.account,
          webTenId: this.$route.query.webTenId,
          password: this.loginForm.password,
        };
        userManagerWebLoginByAccount(form).then((res) => {
          if (res.data.code == 200) {
            this.needLoginVisible = false;
            res.data.data.headimg = res.data.data.webUserAvatarPath
              ? res.data.data.webUserAvatarPath.charAt(0) == "/"
                ? "" + this.myPicPath + res.data.data.webUserAvatarPath
                : this.liveUser.webUserAvatarPath
              : require("@/assets/zsLiveImage/zcr.png");
            let user = res.data.data;
            this.loginForm = {};

            this.userinfo = {
              headimg: res.data.data.headimg,
              userName: res.data.data.webUserName,
              origin: "web",
              userId: res.data.data.webUserId,
            };
            this.liveUser = res.data.data;
            window.localStorage.setItem("liveUser", JSON.stringify(user));
            window.localStorage.setItem("token", user.token);
          }
        });
      }
    },
    initQrCodeImage() {
      this.handleChangeLoginType(2);
    },
    // 切换登录类型
    handleChangeLoginType(loginType) {
      if (loginType == 2) {
        getLoginQrcode({ webTenId: this.$route.query.webTenId }).then((res) => {
          if (res.data.code == 200) {
            this.loginType = loginType;
            this.appQrcodeTry = false;
            var reg = /\\/g; // 加'g'，删除字符串里所有的"a"
            let code = res.data.data.replace(reg, "");
            this.$nextTick(() => {
              this.initMobileQrcode(code);
            });
          }
        });
      } else {
        this.loginType = loginType;
        if (this.mobileCodeTimer) {
          clearInterval(this.mobileCodeTimer);
          this.mobileCodeTimer = null;
        }
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate();
      }
    },
    getMobileEvent(code) {
      var codeReg1 = /SMDL/g;
      var codeReg2 = /\|/g;
      let qrCode1 = code.replace(codeReg1, "");
      let qrCodeJson = qrCode1.replace(codeReg2, "");
      let qrCode = JSON.parse(qrCodeJson).code;
      timeOutGetCode({ code: qrCode }).then((res) => {
        if (res.data.code == 200) {
          clearInterval(this.mobileCodeTimer);
          this.mobileCodeTimer = null;
          if (res.data.data.webUserAvatar) {
            res.data.data.webUserAvatarPath = filePerviewPath({
              downType: "resource",
              fileObjId: res.data.data.webUserAvatar,
            });
          }
          res.data.data.headimg = res.data.data.webUserAvatarPath
            ? res.data.data.webUserAvatarPath.charAt(0) == "/"
              ? "" + this.myPicPath + res.data.data.webUserAvatarPath
              : this.liveUser.webUserAvatarPath
            : require("@/assets/zsLiveImage/video-user-avatar.png");
          window.localStorage.setItem(
            "liveUser",
            JSON.stringify(res.data.data)
          );

          this.userinfo = {
            headimg: res.data.data.headimg,
            userName: res.data.data.webUserName,
            userId: res.data.data.webUserId,
            origin: "web",
          };
          this.liveUser = res.data.data;
          this.needLoginVisible = false;
        } else if (res.data.code !== 99988) {
          clearInterval(this.mobileCodeTimer);
          this.mobileCodeTimer = null;
          this.appQrcodeTry = true;
        }
      });
    },
    // 初始化二维码
    initMobileQrcode(code) {
      QRCode.toCanvas(this.$refs["loginForQrcode"], code, (err) => {
        if (err) throw "错误";
      });
      clearInterval(this.mobileCodeTimer);
      this.mobileCodeTimer = null;
      this.mobileCodeTimer = setInterval(() => {
        this.getMobileEvent(code);
      }, 3000);
    },
    // 建立websocket连接
    // type:网页通知message、活动直播-评论聊天chat、活动直播-互动问答qa、活动直播-图文直播live
    // 来源:手机分享页:wechat; 网页预览:web; 后台运营:admin; App:app;
    // 名称:网页:游客+时间戳; 后台:主持人; app:APP账户昵称; 微信:微信昵称;
    // 后台进入是0 h5是1，web是2
    socketOpen(tabType) {
      console.log(process.env.VUE_APP_HOSTNAME);
      console.log(this.userinfo);
      var websocketId = this.$route.query.webSoleId;
      var type = tabType ? tabType : "chat";
      var origin = this.userinfo.origin;
      var userId = this.userinfo.userId;
      var device = 2;
      // let wsServer = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/websocket/${type}-${websocketId}-${origin}-${userName}-${device}`
      let webTenId = this.$route.query.webTenId || "";
      let hostname =
        process.env.NODE_ENV === "production"
          ? window.location.hostname
          : process.env.VUE_APP_HOSTNAME;
      // let wsServer = `${
      //   location.protocol === "http:" ? "wss" : "wss"
      // }://${hostname}/websocket/${webTenId}-${type}-${websocketId}-${origin}-${userId}-${device}`;
      // 安阳环境 由于分布在不同的服务器 这个地方回头采用分布式目前先写是打包安阳环境的时候
      let wsServer = `${
        location.protocol === "http:" ? "ws" : "wss"
      }://web.aynews.net.cn/websocket/${webTenId}-${type}-${websocketId}-${origin}-${userId}-${device}`;
      this.$setWs.initWebSocket(wsServer); // 调用全局定义socket,传入链接
      setTimeout(() => {
        this.getDetall(type);
      }, 1000);
    },
    // 请求全部信息
    getDetall(type) {
      if (type == "comment") {
        var a = {
          seq: this.uuid,
          type: type,
          chatType: this.tvType,
          data: {
            type: "getall",
            liveId: this.wevsocketId,
          },
        };
      } else {
        var a = {
          seq: this.setUuid(),
          type: type,
          chatType: this.tvType,
          data: {
            type: "getall",
            flag: "1",
            liveId: this.tvId,
            // beginTime: format(Date.now(), "yyyy-MM-dd HH:mm:ss"),
          },
        };
      }

      var a = {
        seq: this.setUuid(),
        type: type,
        chatType: this.tvType,
        data: {
          type: "getall",
          flag: "1",
          liveId: this.tvId,
          // beginTime: format(Date.now(), "yyyy-MM-dd HH:mm:ss"),
        },
      };
      this.$setWs.ws.send(JSON.stringify(a));
    },
    // 设置uuid 随机数
    setUuid() {
      return Number(
        Math.round(Math.random() * 1000) +
          "" +
          Math.round(Math.random() * 10000)
      );
    },
    // 点赞爱心特效
    likeHeart() {
      let praiseBubble = document.getElementById("likeBox");
      console.log(praiseBubble);
      const b = Math.floor(Math.random() * 6) + 1;
      const bl = Math.floor(Math.random() * 11) + 1; // bl1~bl11
      let d = document.createElement("div");
      d.className = `bubble b${b} bl${bl}`;
      d.dataset.t = String(Date.now());
      praiseBubble.appendChild(d);
      // }
    },
    // 统计点赞数
    changeLikeNum() {
      this.addLikeNum++;
      this.likeShow = true;
      console.log(this.addLikeNum);
      this.likeTimer = setInterval(() => {
        this.addLike();
      }, 10000);
    },
    // 增加点赞
    addLike() {
      let params = {
        liveAboutType: 5,
        liveAboutId: this.$route.query.tvid,
        count: this.addLikeNum,
      };
      activityLike(params).then((res) => {
        if (res.data.code == 200) {
          this.likeShow = true;
          // this.$message.success('点赞成功')
          this.addLikeNum = 0;
        }
      });
    },
    // 发表提问
    questions() {
      // 当前是否为登录状态
      if (this.problem == "") {
        Toast("请输入内容");
      } else {
        this.sendqaobj = {
          seq: this.setUuid(),
          type: "qa",
          chatType: this.tvType,
          data: {
            pseq: this.setUuid(),
            messagetype: "send",
            type: "question",
            userid: this.userinfo.userId,
            name: this.userinfo.userName,
            headimg: this.userinfo.headimg,
            showApply: false,
            liveId: this.tvId, //以后会去掉，现在还得传
            message: this.problem,
            word: this.problem,
            flag: 0,
            liveActivityqaAgreecountNum: 0,
            origin: "admin",
            show: "false",
            topflag: 0,
            userforbiddenflag: 0,
          },
        };
        let forbidden = false;
        this.forbiddenData.forEach((item) => {
          if (item.userId == this.sendqaobj.data.userid) {
            forbidden = true;
          }
        });
        if (forbidden) {
          Toast("您已被禁言!");
        } else {
          this.$setWs.ws.send(JSON.stringify(this.sendqaobj));
        }
        this.problem = "";
      }
    },
    // 保留两位小数
    returnFloat(num) {
      num = num.toString(); // 转成字符串类型  如能确定类型 这步可省去
      if (num.indexOf(".") !== -1) {
        let [integerPart, decimalPart] = num.split(".");

        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2);
        } else if (decimalPart.length === 1) {
          decimalPart += "0";
        }
        num = `${integerPart}.${decimalPart}`;
      } else {
        num += ".00";
      }
      return num;
    },
    // 改变礼物数量
    giftSelectChange(val) {
      this.giftRmb = this.returnFloat(this.giftRmb) * val;
    },
    // 赠送礼物按钮
    async giveGift() {
      console.log(this.userinfo);
      this.payment = true;
      this.isPay = 0;
      let res = await atoncePay({
        webGodsType: 3,
        webGodsId: this.onPut.livePropId,
        webOrdAmt: this.giftNum,
        webOrdType: 0,
      });
      this.GenerateQRcode(res.data.data.codeUrl);
      this.giftPrice = this.giftNum * 0.01; //支付价格
      this.timer = setInterval(() => {
        getOrder({
          orderNum: res.data.data.outTradeNo,
        }).then(({ data }) => {
          if (data.code == 200) {
            if (data.data.webOrdStatus == 1) {
              this.isPay = 1;
              this.img = require("../../assets/succ.png");
              // 支付成功
              // websocket发送礼物信息
              this.payment = false;
              this.payClose();
              this.sendGiftMessage(this.onPut);
              clearTimeout(this.timer);
            } else if (data.data.webOrdStatus == 2) {
              this.img = require("../../assets/fail.png");
              this.payment = false;
              this.payClose();
              clearTimeout(this.timer);
            }
          }
        });
      }, 3000);
    },
    // 打开购买链接
    openUrl(url) {
      window.open(url, "_black");
    },
    // 查询已推荐列表
    getRecommend() {
      let obj = {
        liveActivityId: Number(this.tvId),
      };
      activityDetailNotoken(obj).then(({ data }) => {
        this.pageLoad = false;
        if (data.code == 200) {
          this.recommendList = data.data.liveActivityRecommendEntityList; // 推荐列表
        }
      });
    },
    // 发送礼物信息
    sendGiftMessage(row) {
      var a = {
        seq: this.setUuid(),
        chatType: this.tvType,
        data: {
          type: "sendgift",
          userid: this.userinfo.userName,
          name: this.userinfo.userName,
          message: row.livePropName,
          giftid: row.livePropId,
          num: this.giftNum,
          giftimg: this.getImagePathFunc(row),
          headimg: this.userinfo.headimg,
          // "https://news.zsvideo-data.com/defaultAvatar.png",
          liveId: this.tvId, //以后会去掉，现在还得传
          word: this.apply,
        },
      };
      this.$setWs.ws.send(JSON.stringify(a));
    },
    // 获取图片路径
    getImagePathFunc(item) {
      if (item.livePropType) {
        if (!item.livePropImagePath) {
          return require("@/assets/zsLiveImage/noImg.png");
        } else {
          // pathDetail
          let params = {
            fileObjId: item.livePropImagePath,
            downType: "resource",
          };
          return filePerviewPath(params);
        }
      } else {
        return process.env.NODE_ENV === "production"
          ? window.baseUrl + "/"
          : process.env.VUE_APP_BASE_API + "download" + item.livePropImagePath;
      }
    },
    getItem(item) {
      console.log(item);
      this.onPut = item;
      this.giftNum = 1;
      this.giftRmb = item.livePropPrice;
    },
    // 生成二维码
    GenerateQRcode(val) {
      new QRCode2("payQrcode", {
        // 此处的qrcode为上面div的id
        // text: val,
        text: val,
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode2.CorrectLevel.H,
      });
    },
    // 关闭支付弹窗
    payClose() {
      this.giftNum = null;
      this.giftRmb = 0;
    },
    //聊天框一直在底部
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.commentBox) {
          console.log(this.$refs.commentBox.scrollHeight);
          this.$refs.commentBox.scrollTop = this.$refs.commentBox.scrollHeight;
        }
      });
    },
    // 获取图片地址
    returnImgPath(id) {
      if (!id) {
        // return require("@/assets/img/fileicon/noImg.png")
      } else {
        let params = {
          fileObjId: id,
          downType: "cover",
        };
        return filePerviewPath(params);
      }
    },
    // 获取图文直播 图片list
    getImageList(list) {
      var arr = [];
      list.forEach((item) => {
        arr.push(this.getFilePath(item.fileId));
      });
      return arr;
    },
    getFilePath(item) {
      return filePerviewPath({ downType: "resource", fileObjId: item });
    },

    getPerviewImg(fileObjId) {
      return filePerviewPath({
        downType: "resource",
        fileObjId,
      });
    },
    // 打开推荐链接
    openTextUrl(item) {
      console.log(item);
      let url = "";
      if (item.liveActivityRecommendReleaseType == "1") {
        //文稿
        this.mobileShareObj.forEach((val) => {
          if (val.comConfKey == "ZsCloudUrlNewsShare") {
            url = `${val.webConfValue}?id=${item.liveActivityRecommendReleaseid}&type=${item.liveActivityRecommendReleaseType}&webTenId=${this.$route.query.webTenId}`;
          }
        });
      } else if (item.liveActivityRecommendReleaseType == "2") {
        // 视频
        this.mobileShareObj.forEach((val) => {
          if (val.comConfKey == "ZsCloudUrlVideoShare") {
            url = `${val.webConfValue}?id=${item.liveActivityRecommendReleaseid}&type=${item.liveActivityRecommendReleaseType}&webTenId=${this.$route.query.webTenId}`;
          }
        });
      } else if (item.liveActivityRecommendReleaseType == "3") {
        // 音频
        this.mobileShareObj.forEach((val) => {
          if (val.comConfKey == "ZsCloudUrlAudioShare") {
            url = `${val.webConfValue}?id=${item.liveActivityRecommendReleaseid}&type=${item.liveActivityRecommendReleaseType}&webTenId=${this.$route.query.webTenId}`;
          }
        });
      } else if (item.liveActivityRecommendReleaseType == "4") {
        // 图集
        this.mobileShareObj.forEach((val) => {
          if (val.comConfKey == "ZsCloudUrlPictureShare") {
            url = `${val.webConfValue}?id=${item.liveActivityRecommendReleaseid}&type=${item.liveActivityRecommendReleaseType}&webTenId=${this.$route.query.webTenId}`;
          }
        });
      } else if (item.liveActivityRecommendReleaseType == "5") {
        // 外链
        url = item.liveActivityRecommendLink;
      } else if (
        item.liveActivityRecommendReleaseType == "6" ||
        item.liveActivityRecommendReleaseType == "10" ||
        item.liveActivityRecommendReleaseType == "7" ||
        item.liveActivityRecommendReleaseType == "16"
      ) {
        let type = "";
        switch (item.liveActivityRecommendReleaseType) {
          case "6":
            type = 1;
            break;
          case "7":
            type = 2;
            break;
          case "10":
            type = 3;
            break;
          case "16":
            type = 4;
            break;
        }
        url = `${window.location.origin}/liveView?tvid=${item.liveActivityRecommendReleaseid}&webTenId=${this.$route.query.webTenId}&tvType=${type}&webSoleId=${item.webSoleId}`;
      } else if (item.liveActivityRecommendReleaseType == "8") {
        // 活动直播
        url = `${window.location.origin}/liveView?tvid=${item.liveActivityRecommendReleaseid}&webTenId=${this.$route.query.webTenId}&tvType=5&webSoleId=${item.webSoleId}`;
      } else if (item.liveActivityRecommendReleaseType == "9") {
        // 融媒体电视直播
        this.mobileShareObj.forEach((val) => {
          if (val.comConfKey == "ZsCloudUrlAudioShare") {
            url = `${val.webConfValue}?id=${item.liveActivityRecommendReleaseid}&type=${item.liveActivityRecommendReleaseType}&webTenId=${this.$route.query.webTenId}`;
          }
        });
      }
      window.open(url, "_balck");
    },
    // 同问
    setProblem(item, index, top) {
      forbiddenuserAddCount({ liveActivityqaId: item.data.messageid })
        .then((res) => {
          if (res.data.code == 200) {
            item.data.Enter = true;
            item.data.liveActivityqaAgreecountNum++;
            if (top === "top") {
              this.$set(this.topList, index, item);
              this.messageData.topList = this.topList;
            } else {
              this.$set(this.questionList, index, item);
              this.messageData.questionList = this.questionList;
            }
            this.$setWs.messages = this.messageData;
            let arr = JSON.stringify(this.messageData);
            store.commit("web_socket_msg", arr);
            Toast("操作成功!");
          }
        })
        .catch(() => {
          Toast("数据异常!");
        });
    },
    // 取消同问
    unSetProblem(item, index, top) {
      forbiddenuserMinuscount({ activityqaid: item.data.messageid })
        .then((res) => {
          if (res.data.code == 200) {
            item.data.Enter = false;
            item.data.liveActivityqaAgreecountNum--;
            if (top === "top") {
              this.$set(this.topList, index, item);
              this.messageData.topList = this.topList;
            } else {
              this.$set(this.questionList, index, item);
              this.messageData.questionList = this.questionList;
            }
            this.$setWs.messages = this.messageData;
            let arr = JSON.stringify(this.messageData);
            store.commit("web_socket_msg", arr);
            Toast("操作成功!");
          }
        })
        .catch(() => {
          Toast("数据异常!");
        });
    },
    // 分享至微信
    shareWx() {
      if(localStorage.getItem('userinfo')){
        this.appShare(window.location.href,this.liveDataInfo.liveActivityTitle,'',this.liveDataInfo.liveActivityTitle.coverimgPath)
      } else {
        this.getMyLoginStatus()
      }
    },
    // 打开回复框
    replayMsg() {
      if(this.liveUser.token){
        this.replayShow = !this.replayShow;
      }
      else{
        this.getMyLoginStatus()
      }
    },
    //获取登录状态
    getMyLoginStatus() {
      this.setNeedLoginType(true);
      appOrh5Login("questions");
      this.userLoginStatus = localStorage.getItem("userLoginStatus");
    },
    // 输入框失去焦点
    inputBlur() {
      // 为输入框添加blur事件监听器
      // 隐藏软键盘
      if (navigator.userAgent.match(/iPhone/i)) {
        document.getElementById("myInput").blur();
      } else if (navigator.userAgent.match(/Android/i)) {
        // 对于Android设备，可能需要特定的代码来隐藏软键盘
        // 例如，可以调用隐藏软键盘的方法
        // 假设有一个方法
        hideKeyboard(); //可以隐藏键盘
        // hideKeyboard(); }
      }
    },
   
    // 获取服务器文档路径
    getSetting() {
      configurationManagerSingle({
        comConfKey: "FileBasePath",
        comConfType: "0",
      }).then((res) => {
        if (res.data.code == 200) {
          this.giftBaseUrl = res.data.data.comConfDef;
          this.myPicPath = res.data.data.comConfDef;
        }
      });
      // 获取CMS域名地址  用于iframe 通讯
      // configurationManagerSingle({
      //   comConfKey: "LiveCmsWebUrl",
      //   comConfType: "1",
      // }).then(resp=>{
      //   console.log(resp)
      //   if(resp.data.data.webConfValue){
      //     this.iframeCommunicationDomain = resp.data.data.webConfValue
      //     if(this.originType) this.localPath = this.iframeCommunicationDomain + 'ayinfo/' + this.$route.query.infoId
      //     else this.localPath = window.location.href
      //   }else{
      //     this.$message.warning('请联系管理员配置系统项！')
      //   }
      // })
      configurationGroup({
        comConfType: 10,
      }).then((res) => {
        if (res.data.code == 200) {
          this.mobileShareObj = res.data.data[0].childrens;
          console.log(this.mobileShareObj);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./zscmsLiveMixin.scss";

.rightBox {
  width: 100%;
  //padding: 0 15px 0px 15px;
  background: #f9f9f9;
  height: 100%;
  box-sizing: border-box;

  @include large {
    // padding: 30px 20px;
  }
  .tab-box {
    width: 100%;
    height: 50px;
    .tabs-header {
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 50px;
      line-height: 50px;
      background-color: #fff;
      .navItem {
        position: relative;
        font-size: 16px;
        color: #666666;
      }
      .active {
        position: relative;
        color: #d42424;
        font-weight: bold;
        z-index: 2;
      }
      .active::after {
        position: absolute;
        content: "";
        width: 90%;
        height: 4px;
        background-color: rgba(255, 183, 191, 0.8);
        bottom: 18px;
        left: 60%;
        transform: translate(-50%);
        z-index: -1;
      }
    }
  }
  .tabsRight {
    position: fixed;
    right: 0px;
    bottom: 10px;
    width: 74px;
    padding: 6px;
    box-sizing: border-box;
    .share,
    .replay {
      width: 100%;
      height: 62px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .replayDetailsBox {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 110;
    .replayDetails {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: 60px;
      position: fixed;
      bottom: 0px;
      z-index: 50;
      background-color: #fff;
      .userHeaderImg {
        width: 9%;
        height: 36px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .replayInput {
        width: 60%;
        margin-left: 10px;
        .video-login-tip {
          width: 100%;
          height: 36px;
          line-height: 36px;
          padding-left: 20px;
          box-sizing: border-box;
          background-color: #f2f2f2;
          border-radius: 20px;
          font-size: 12px;
          color: #999;
          margin-right: 2px;

          @include large {
            font-size: 14px;
            margin-right: 22px;
          }
        }
      }
      .replayBtn {
        width: 18%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        font-weight: bold;
        background-color: #e9616d;
        border-radius: 20px;
      }
    }
  }

  .tab-content {
    width: 100%;
    // height: 96%;
    overflow: hidden;
    overflow-y: auto;
    background-color: #f9f9f9;

    // 边看边买
    .comment-list {
      width: 100%;

      // 边看边买item
      .newmenu-content-buy-item {
        display: flex;
        justify-content: space-between;
        // padding: 16px 0;

        // border-bottom: 1px solid #f1f1f1;
        .newmenu-content-buy-item {
          position: relative;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          width: 75px;
          height: 75px;
          border-radius: 4px;
          background: #f5f5f5;
          overflow: hidden;
          flex: 0 0 75px;
          margin-right: 12px;

          img {
            width: 100%;
            height: 100%;
          }

          @include large {
            width: 100px;
            height: 100px;
            flex: 0 0 100px;
          }
        }

        .newmenu-content-buy-item-right-content {
          flex: 0 0 158px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          @include large {
            flex: 0 0 218px;
          }

          .newmenu-content-buy-item-right-content-title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 14px;
            color: $titleColor;
            height: 42px;
            line-height: 21px;

            @include large {
              height: 48px;
              font-size: 16px;
              line-height: 24px;
            }
          }

          .newmenu-content-buy-item-right-content-btn {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .buy-price {
              height: 22px;
              line-height: 22px;
              color: #3d7ddc;
              font-size: 12px;

              @include large {
                height: 28px;
                font-size: 16px;
                line-height: 28px;
              }
            }

            .buy-btn {
              cursor: pointer;
              width: 60px;
              height: 22px;
              line-height: 22px;
              text-align: center;
              background: #3d7ddc;
              color: #fff;
              border-radius: 20px;

              @include large {
                width: 72px;
                height: 28px;
                font-size: 14px;
                line-height: 28px;
              }
            }
          }
        }

        &:hover .newmenu-content-buy-item-right-content-title {
          color: #3d7ddc;
        }
      }
    }

    // 互动聊天
    .ev-detail-cont-commen {
      width: 100%;
      color: $titleColor;
      font-size: 14px;

      @include large {
        font-size: 16px;
      }

      .comment-list {
        // height: auto;
        // overflow: auto;
        // -ms-overflow-style: none;
        // overflow: -moz-scrollbars-none;
        &::-webkit-scrollbar {
          width: 0 !important;
        }

        /deep/ .el-card.is-always-shadow {
          box-shadow: none;
        }

        .answer-twzb {
          overflow: hidden;
          overflow-y: auto;

          .box-card {
            border: none !important;

            /deep/.el-card__body {
              height: 100%;
              padding: 10px 20px;
            }

            .border-box {
              // margin-top: 70px;
              .item {
                margin-bottom: 17px;

                // border-bottom: 1px solid #f1f1f1;
                // padding-bottom: 16px;
                .text-msg {
                  display: flex;

                  .avatar-img {
                    flex: 0 0 28px;
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    overflow: hidden;

                    img {
                      width: 28px;
                      height: 28px;
                      object-fit: cover;
                    }
                  }

                  .zcrcalss {
                    margin-left: 8px;
                    height: 38px;
                    display: flex;
                    justify-content: space-between;
                    width: 90%;
                    .user-name {
                      font-size: 14px;
                      color: $titleColor;
                      line-height: 21px;
                      height: 21px;
                      font-weight: bold;

                      .user-info {
                        display: inline-block;
                        width: 32px;
                        height: 16px;
                        border-radius: 4px;
                        color: #fff;
                        font-size: 12px;
                        text-align: center;
                        line-height: 16px;
                      }
                    }

                    .createtime {
                      font-size: 12px;
                      color: #999;
                      line-height: 17px;
                      height: 17px;
                    }
                  }
                }

                .twcontent {
                  margin-left: 36px;
                  box-sizing: border-box;
                  padding: 10px 10px;
                  background-color: #fff;
                  .gift-msg {
                    display: flex;
                    align-items: center;
                    background: #f5f5f5;
                    border-radius: 20px;
                    min-width: 200px;
                    margin: 0 auto;
                    justify-content: center;

                    .gift-word {
                      line-height: 32px;
                      font-size: 14px;
                      color: #333333;
                      height: 32px;

                      span {
                        font-size: 12px;
                        color: #999999;
                        margin-right: 8px;
                      }
                    }

                    .gift-img {
                      width: 15px;
                      height: 15px;
                      margin-left: 8px;

                      img {
                        width: 100%;
                        height: 100%;
                      }
                    }
                  }
                }
              }
            }

            // 图文直播样式
            .twzb-border-box {
              .item {
                margin-bottom: 17px;
                border-bottom: 1px solid #f1f1f1;
                padding-bottom: 16px;

                .twzb-msg {
                  .text-msg {
                    display: flex;

                    .avatar-img {
                      flex: 0 0 28px;
                      width: 28px;
                      height: 28px;
                      border-radius: 50%;
                      overflow: hidden;

                      img {
                        width: 28px;
                        height: 28px;
                        object-fit: cover;
                      }
                    }

                    .zcrcalss {
                      margin-left: 8px;
                      height: 38px;

                      .user-name {
                        font-size: 14px;
                        color: $titleColor;
                        line-height: 21px;
                        height: 21px;
                        font-weight: bold;

                        .topping {
                          display: inline-block;
                          width: 20px;
                          font-size: 14px;
                          height: 20px;
                          line-height: 21px;
                          background-color: #f83939;
                        }

                        .user-info {
                          display: inline-block;
                          width: 32px;
                          height: 16px;
                          border-radius: 4px;
                          color: #fff;
                          font-size: 12px;
                          text-align: center;
                          line-height: 16px;
                        }
                      }

                      .createtime {
                        font-size: 12px;
                        color: #999;
                        line-height: 17px;
                        height: 17px;
                      }
                    }
                  }

                  .zcrcalss-twzb {
                    .twcontent {
                      margin-left: 36px;
                    }

                    .twcontent_image_list {
                      margin-left: 36px;
                      display: flex;
                      flex-wrap: wrap;

                      .twcontent_image_list_image {
                        border-radius: 4px;
                        flex: 0 0 68px;
                        height: 46px;
                        width: 68px;
                        overflow: hidden;
                        margin-right: 8px;

                        @include large {
                          flex: 0 0 92px;
                          width: 92px;
                          height: 62px;
                          margin-right: 10px;
                        }

                        &:nth-child(3n) {
                          margin: 0;
                        }

                        &:nth-child(n + 4) {
                          margin-top: 10px;
                        }
                      }
                    }
                  }
                }
              }
            }

            // 互动问答
            .qa-border-box {
              .top-list {
                .item {
                  .text-msg {
                    display: flex;

                    .avatar-img {
                      flex: 0 0 28px;
                      width: 28px;
                      height: 28px;
                      border-radius: 50%;
                      overflow: hidden;

                      img {
                        width: 28px;
                        height: 28px;
                        object-fit: cover;
                      }
                    }

                    .zcrcalss {
                      margin-left: 8px;
                      height: 38px;

                      .user-name {
                        font-size: 14px;
                        color: $titleColor;
                        line-height: 21px;
                        height: 21px;
                        position: relative;
                        width: 205px;
                        font-weight: bold;

                        @include large {
                          width: 251px;
                        }

                        .user-info {
                          display: inline-block;
                          width: 32px;
                          height: 16px;
                          border-radius: 4px;
                          color: #fff;
                          font-size: 12px;
                          text-align: center;
                          line-height: 16px;
                        }

                        .right-btn {
                          position: absolute;
                          top: 2px;
                          right: 0px;
                        }
                      }

                      .createtime {
                        font-size: 12px;
                        color: #999;
                        line-height: 17px;
                        height: 17px;
                      }
                    }
                  }

                  .twcontent {
                    .question-box {
                      display: flex;
                      margin-top: 12px;
                      margin-left: 16px;
                      .question-left {
                        margin-right: 6px;
                      }
                    }

                    .answer-box {
                      margin-top: 12px;

                      .answer-box-content {
                        display: flex;
                        align-content: center;
                        margin-left: 16px;

                        .answer-left {
                          margin-right: 6px;
                        }

                        .answer-right {
                          font-size: 16px;
                          color: $titleColor;
                        }
                      }
                    }
                  }
                }
              }

              .untop-list {
                .item {
                  .text-msg {
                    display: flex;

                    .avatar-img {
                      flex: 0 0 28px;
                      width: 28px;
                      height: 28px;
                      border-radius: 50%;
                      overflow: hidden;

                      img {
                        width: 28px;
                        height: 28px;
                        object-fit: cover;
                      }
                    }

                    .zcrcalss {
                      margin-left: 8px;
                      height: 38px;

                      .user-name {
                        font-size: 14px;
                        color: $titleColor;
                        line-height: 21px;
                        height: 21px;
                        position: relative;
                        width: 205px;
                        font-weight: bold;

                        @include large {
                          width: 251px;
                        }

                        .user-info {
                          display: inline-block;
                          width: 32px;
                          height: 16px;
                          border-radius: 4px;
                          color: #fff;
                          font-size: 12px;
                          text-align: center;
                          line-height: 16px;
                        }

                        .right-btn {
                          position: absolute;
                          top: 2px;
                          right: 0px;
                        }
                      }

                      .createtime {
                        font-size: 12px;
                        color: #999;
                        line-height: 17px;
                        height: 17px;
                      }
                    }
                  }

                  .twcontent {
                    .question-box {
                      display: flex;
                      margin-top: 12px;
                      margin-left: 16px;

                      .question-left {
                        margin-right: 6px;
                      }
                    }

                    .answer-box {
                      margin-top: 12px;

                      .answer-box-content {
                        display: flex;
                        margin-left: 16px;

                        .answer-left {
                          margin-right: 6px;
                        }

                        .answer-right {
                          font-size: 16px;
                          color: $titleColor;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    // 互动聊天输入框
    .question-msg-input {
      margin-top: 10px;

      .character-info {
        position: relative;
        display: flex;
        height: 28px;
        align-items: center;

        @include large {
          height: 36px;
        }

        .character {
          flex: 0 0 28px;
          margin-right: 8px;
          height: 100%;

          @include large {
            flex: 0 0 36px;
            margin-right: 12px;
          }

          .avatar-img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .character-send-content {
          flex: 0 0 185px;
          display: flex;
          background: #f5f5f5;
          align-items: center;
          padding: 0 8px 0 0;
          height: 28px;
          line-height: 28px;
          margin-right: 8px;
          justify-content: space-between;
          box-sizing: content-box;

          @include large {
            flex: 0 0 242px;
            // padding: 0px 12px 0 0;
            height: 36px;
          }

          .video-login-tip {
            font-size: 12px;
            color: #999;
            margin-right: 2px;

            @include large {
              font-size: 14px;
              margin-right: 22px;
            }
          }

          .character-send-actions {
            display: flex;

            .character-send-actions-emoji {
              cursor: pointer;
              width: 20px;
              height: 20px;
              margin-right: 4px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .character-send-actions-send {
              cursor: pointer;
              width: 20px;
              height: 20px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          /deep/.el-input__inner {
            border: unset;
            background: #f5f5f5;
          }
        }

        .likeBox {
          position: absolute;
          right: -5px;
          bottom: 60px;
          width: 50px;
          height: 50px;
          box-sizing: border-box;
          padding: 10px;
          background-color: rgba(0, 0, 0, 0);
          box-shadow: rgb(240, 240, 240) 2px 2px 10px 2px;
        }
      }
    }

    // 直播推荐
    .recommendList-content {
      width: 100%;
      min-height: 500px;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;

      .recommendList-content-item {
        display: flex;
        padding-bottom: 16px;
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: 16px;

        .recommendList-content-item-left-img {
          width: 94px;
          height: 63px;
          overflow: hidden;
          border-radius: 4px;
          background: #c4c4c4;
          flex: 0 0 94px;
          margin-right: 12px;

          @include large {
            flex: 0 0 125px;
            width: 125px;
            height: 84px;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .recommendList-content-item-right-content {
          flex: 0 0 149px;
          width: 149px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          @include large {
            width: 193px;
            flex: 0 0 193px;
          }

          .recommendList-item-title {
            font-size: 14px;
            color: $titleColor;
            overflow: hidden;
            height: 40px;
            line-height: 20px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            @include large {
              height: 48px;
              line-height: 24px;
              font-size: 16px;
            }
          }

          .recommendList-item-time {
            font-size: 12px;
            color: $spanColor;

            @include large {
              font-size: 14px;
            }
          }
        }
      }
    }

    // 节目单
    .date-items {
      .day {
        height: 78px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        div {
          height: 21px;
          line-height: 21px;
          font-size: 14px;
        }
      }

      /deep/.el-tabs__item {
        height: 78px;
      }

      /deep/.el-tabs__nav-prev {
        top: 50% !important;
        transform: translateY(-50%) !important;
      }

      /deep/.el-tabs__nav-next,
      .el-tabs__nav-prev {
        top: 50% !important;
        transform: translateY(-50%) !important;
      }

      /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
        border: none !important;
      }

      /deep/.el-tabs--card > .el-tabs__header .el-tabs__item {
        border: none !important;
      }

      .table-parent {
        /deep/.cell {
          padding: 0 !important;
        }

        /deep/.cell {
          padding: 0 !important;
        }
      }
    }
  }

  .ev-detail-cont-commen {
    width: 100%;
    color: $titleColor;
    font-size: 14px;

    @include large {
      font-size: 16px;
    }
  }

  .content-text {
    word-break: break-all;

    // margin-top: 8px;
    /deep/img {
      max-width: 100%;
    }
  }
}

/deep/ .my_login_dialog {
  .el-dialog__header {
    border: none !important;
  }
}

.my_login_title {
  width: 100%;

  .my_login_title_toogle {
    display: flex;

    .my_login_title_toogle_image {
      display: flex;
      align-items: flex-start;

      img {
        cursor: pointer;
      }
    }
  }
}

.my_login_content {
  padding: 0 30px;

  .my_login_content_header {
    display: flex;
    align-items: baseline;

    .my_login_content_header_item {
      color: #999999;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
    }

    .my_login_content_header_item_selected {
      color: #333333;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .my_login_content_form {
    .my_login_content_form_item {
      margin-top: 30px;
      display: flex;

      .login_svg_item {
        width: 18px;
        align-items: center;
        display: flex;
        height: 100%;
      }

      .my_login_content_form_item_code_btn {
        margin-left: 10px;
        flex: 0 0 108px;
        width: 108px;
        height: 40px;
        line-height: 40px;
        color: #3d7ddc;
        font-size: 14px;
        text-align: center;
        background: #f2f2f6;
        border: 1px solid #dfe3e8;
        border-radius: 4px;
      }
    }

    .my_login_content_form_action {
      margin-top: 47px;
      margin-bottom: 20px;
    }

    .my_login_content_form_user {
      font-size: 12px;
      color: #999;

      span {
        color: #3d7ddc;
      }
    }

    .my_login_content_third_count {
      display: flex;
      justify-content: space-between;
      padding: 32px 70px;

      .my_login_content_third_item {
        width: 40px;
        height: 40px;
        flex: 0 0 40px;
        cursor: pointer;
      }

      .my_login_content_third_item_qq {
        background: url("../../assets/zsLiveImage/login/qq.png") no-repeat;
        background-size: 100%;

        &:hover {
          background-image: url("../../assets/zsLiveImage/login/qq_hover.png");
        }
      }

      .my_login_content_third_item_weibo {
        background: url("../../assets/zsLiveImage/login/weibo.png") no-repeat;
        background-size: 100%;

        &:hover {
          background-image: url("../../assets/zsLiveImage/login/weibo_hover.png");
        }
      }

      .my_login_content_third_item_weixin {
        background: url("../../assets/zsLiveImage/login/weixin.png") no-repeat;
        background-size: 100%;

        &:hover {
          background-image: url("../../assets/zsLiveImage/login/weixin_hover.png");
        }
      }
    }
  }

  .my_login_content_Qrcode_title {
    text-align: center;
    color: #333;
    font-size: 18px;
    margin-bottom: 20px;
    margin-top: 50px;
    font-weight: 700;
  }

  .my_login_content_qrcode_content {
    width: 170px;
    height: 170px;
    border: 1px solid #d8d8d8;
    padding: 11px;
    position: relative;
    margin: 0 auto;
    margin-bottom: 100px;

    .loginForQrcode {
      width: 148px !important;
      height: 148px !important;
    }

    .qrCodeTryAgagin {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      z-index: 9999;
      position: absolute;
      top: 0;
      left: 0;

      .my_qrCodeTryAgagin_button {
        position: absolute;
        top: 50%;
        left: 50%;
        color: #fff;
        font-size: 30px;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
  }
}

.gift-box {
  position: relative;
  // margin-left: 12px;
}

.gift-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
  max-height: 164px;
  overflow: hidden;
  overflow-y: auto;

  .gift-item {
    flex: 0 0 56px;
    margin-right: 8px;

    &:nth-child(4n) {
      margin-right: 0;
    }

    .gift-card {
      border: 1px solid #f1f1f1;
      padding: 8px 0 4px 0;
      border-radius: 4px;
      overflow: hidden;

      .gift-img {
        width: 30px;
        height: 30px;
        margin: 0 auto;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .gift-price {
        margin-top: 4px;
        line-height: 18px;
        text-align: center;
        font-size: 12px;
        color: #999;
      }
    }

    .gift-active {
      padding-top: 10px;
      border: 1px solid #1286d3;
      width: 55px;
      height: 64px;
      background: #ffffff;
      border-radius: 4px;
      cursor: pointer;
    }

    .gift-name {
      margin-top: 4px;
      line-height: 18px;
      text-align: center;
      font-size: 12px;
      color: #999;
    }
  }
}

.gift-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
}

.to-paid {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: url("../../assets/qs.png") no-repeat;
  width: 284px;
  height: 284px;
  background-size: 100%;
}
.merryGoRound {
  position: fixed;
  width: 90%;
  background-color: #f9f9f9;
  /deep/ .el-carousel__container{
    max-height: 135px;
  }
}
.user_send_msg_item {
  display: flex;
  // padding: 0 20px;
  .user_send_msg_item_avatar {
    margin-right: 12px;
  }
  .user_send_msg_item_info {
    display: flex;
    width: 89%;
    // flex-direction: column;
    justify-content: space-between;
    height: 35px;
    .user_send_msg_item_nick_info {
      display: flex;
      .user_send_msg_item_nick_info_name {
        font-size: 14px;
        color: #6e6e7a;
        margin-right: 8px;
        font-weight: bold;
      }
      .user_send_msg_item_offic {
        width: 33px;
        height: 16px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .avatar-img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .user_send_msg_item_info_time {
      color: #a8b1bb;
      font-size: 12px;
    }
  }
}
.user_send_msg_content {
  width: 85%;
  margin-left: 10%;
  margin-top: -5px;
  color: #6e6e7a;
  overflow: hidden;
  overflow-y: auto;
  height: 70px;
  font-size: 14px;
  padding: 6px 10px 10px 14px;
  background-color: #ffeff1;
}
.user_send_msg {
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: 4px;
}
.payment img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/.el-dialog.pay_dialog {
  background: rgba(0, 0, 0, 0.6);
}

/deep/ .pay_dialog .el-dialog__header {
  border: none;
  padding: 0;
}

/deep/ .pay_dialog .el-dialog__header .el-dialog__headerbtn {
  top: 69% !important;
  left: 50%;
  border: 1px solid #fff;
  border-radius: 50%;
  font-size: 20px;
  height: 28px;
  width: 28px;
}
/deep/ .el-card__body {
  background-color: #f9f9f9;
}
/deep/.pay_dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
</style>